import NotFoundBanner from "./NotFound"

export default NotFoundBanner;